import { remCalc } from "../theme/style-utils-coras-nua";
import styled from "styled-components";
import defaultTheme from "../theme/theme-test-override";

const StyledListChecked = styled("ul")`
    list-style: none;
    padding-left: 0;
    > li {
        position: relative;
        margin-left: 0;
        padding: ${remCalc(10)} 0 ${remCalc(10)} ${remCalc(32)};
        &:before {
            content: url("data:image/svg+xml,%3Csvg width='16px' height='14px' viewBox='0 0 16 14' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Ctitle%3Echeck-list%3C/title%3E%3Cg id='check-list' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cpath d='M14.100372,0.89044387 C14.4683813,0.44182986 15.1396248,0.36909516 15.5996364,0.72798636 C16.0085356,1.04700077 16.1128983,1.59967135 15.8725772,2.03362454 L15.7662214,2.19010388 L6.48843089,13.5 L0.312418666,7.47700935 C-0.104139555,7.07077209 -0.104139555,6.41213136 0.312418666,6.0058941 C0.682692642,5.64479431 1.25746329,5.60467211 1.67318097,5.8855275 L1.82090943,6.0058941 L6.31038451,10.3843567 L14.100372,0.89044387 Z' id='Combined-Shape' fill='%230000FF' fill-rule='nonzero'%3E%3C/path%3E%3C/g%3E%3C/svg%3E");
            height: ${remCalc(16)};
            position: absolute;
            top: ${remCalc(20)};
            left: ${remCalc(0)};
            transform: translateY(-50%);
        }
    }
`;
StyledListChecked.defaultProps = {
    theme: {
        ...defaultTheme
    }
};

const StyledListUnordered = styled("ul")`
    color: ${props => props.theme.colors.monotoneMidDark};
    font-size: ${remCalc(15)};
    li {
        padding: ${remCalc(10)} 0;
    }
`;

StyledListUnordered.defaultProps = {
    theme: {
        ...defaultTheme
    }
};

const StyledListOrdered = styled("ol")`
    color: ${props => props.theme.colors.monotoneDark};
    font-size: ${props => props.fontSize};
    li {
        padding: ${remCalc(5)} ${remCalc(10)};
    }
`;

StyledListOrdered.defaultProps = {
    theme: {
        ...defaultTheme
    },
    fontSize: remCalc(15)
};

export { StyledListChecked, StyledListUnordered, StyledListOrdered };
